import { PromptModal } from './PromptDetails';

export default PromptModal;
